export var appConfig = {
  // insaServiceAddress: "https://www.insa-support.com/InsaWebApi/api",
  // authServiceAddress: "https://www.insa-support.com/InsaWebApi",
  // pivotViewerServiceAddress: "https://www.insa-support.com/InsaWebApi"
  // insaServiceAddress: "http://localhost:51438/api",
   //authServiceAddress: "http://localhost:51438",
  insaServiceAddress: "https://insaweb.luganowealth.com/InsaWebApi/api",
  authServiceAddress: "https://insaweb.luganowealth.com/InsaWebApi",
  pivotViewerServiceAddress: "https://insaweb.luganowealth.com/InsaWebApi"
}


// WEBPACK FOOTER //
// ./insa-css/insa-clients/LWP/insaweb.service.config.ts